"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionDeleteReferenceAfterDelete = exports.FieldDeleteStep = void 0;
const __1 = require("../../..");
const FunctionRemoveObjectFromError = (data) => {
    const createNewData = data === null || data === void 0 ? void 0 : data.map((row) => {
        const keys = Object.keys(row);
        const newObject = {};
        keys.forEach((key) => {
            var _a, _b, _c;
            if (typeof row[key] !== "object") {
                newObject[key] = row[key];
            }
            if (typeof row[key] === "object" && ((_a = row[key]) === null || _a === void 0 ? void 0 : _a.error)) {
                newObject[key] = (_b = row[key]) === null || _b === void 0 ? void 0 : _b.value;
            }
            if (typeof row[key] === "object" && !((_c = row[key]) === null || _c === void 0 ? void 0 : _c.error)) {
                newObject[key] = row[key];
            }
        });
        // console.log("newObject", newObject);
        return newObject;
    });
    // console.log("DATA : ", { data, createNewData });
    return createNewData;
};
const FieldDeleteStep = (props, index, setThisStep, setKeepData, setDeleteindex) => {
    var _a;
    if (props === null || props === void 0 ? void 0 : props.triggerDelete) {
        props === null || props === void 0 ? void 0 : props.triggerDelete(props, index);
    }
    setThisStep((prev) => {
        let temp = [...prev];
        temp.splice(index, 1);
        return temp;
    });
    if ((props === null || props === void 0 ? void 0 : props.parentIndex) >= 0) {
        if (props.grandParentKey === props.parentKey) {
            if ((_a = props.FieldReference.current[props.parentIndex][props.parentKey]) === null || _a === void 0 ? void 0 : _a.length) {
                let cloneData = (0, __1.FunctionCloneDeep)(props.FieldReference.current[props.parentIndex][props.parentKey]);
                cloneData.splice(index, 1);
                setKeepData({
                    [props.parentKey]: FunctionRemoveObjectFromError(cloneData),
                });
                setDeleteindex(index);
            }
        }
        else {
            if (props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey].length) {
                let cloneData = (0, __1.FunctionCloneDeep)(props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey]);
                cloneData.splice(index, 1);
                const newData = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex]), { [props.grandParentKey]: Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey]), { [props.parentIndex]: Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex]), { [props.parentKey]: FunctionRemoveObjectFromError(cloneData) }) }) });
                setKeepData(newData);
                setDeleteindex(index);
            }
        }
    }
    else {
        if ((props === null || props === void 0 ? void 0 : props.grandParentIndex) >= 0) {
            let cloneData = (0, __1.FunctionCloneDeep)(props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey]);
            cloneData.splice(index, 1);
            const newData = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex]), { [props.grandParentKey]: Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey]), { [props.parentKey]: cloneData }) });
            // console.log("IN PROPS ", {
            //   props,
            //   index,
            //   cloneData,
            //   newData,
            // });
            setKeepData(newData);
            setDeleteindex(index);
        }
    }
    // setTimeout(() => {
    //   if (props.grandParentKey === props.parentKey) {
    //     if (
    //       props.FieldReference.current[props.parentIndex][props.parentKey]?.length
    //     ) {
    //       props.FieldReference.current[props.parentIndex][props.parentKey].splice(
    //         index,
    //         1
    //       );
    //     }
    //   } else {
    //     if (
    //       props.FieldReference.current[props.grandParentIndex][
    //         props.grandParentKey
    //       ][props.parentIndex][props.parentKey].length
    //     ) {
    //       props.FieldReference.current[props.grandParentIndex][
    //         props.grandParentKey
    //       ][props.parentIndex][props.parentKey].splice(index, 1);
    //     }
    //   }
    // }, 50);
};
exports.FieldDeleteStep = FieldDeleteStep;
const FunctionDeleteReferenceAfterDelete = (props, index, setDeleteindex) => {
    var _a;
    if ((props === null || props === void 0 ? void 0 : props.parentIndex) >= 0) {
        if (props.grandParentKey === props.parentKey) {
            if ((_a = props.FieldReference.current[props.parentIndex][props.parentKey]) === null || _a === void 0 ? void 0 : _a.length) {
                props.FieldReference.current[props.parentIndex][props.parentKey].splice(index, 1);
                setDeleteindex(-1);
            }
        }
        else {
            if (props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey].length) {
                props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey].splice(index, 1);
                setDeleteindex(-1);
            }
        }
    }
    else {
        if ((props === null || props === void 0 ? void 0 : props.grandParentIndex) >= 0) {
            if (props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey].length) {
                props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey].splice(index, 1);
                setDeleteindex(-1);
            }
        }
    }
};
exports.FunctionDeleteReferenceAfterDelete = FunctionDeleteReferenceAfterDelete;
